import { Pipe } from '@angular/core';
import { isString } from '../helpers/helpers';
var TestPipe = (function () {
    function TestPipe() {
    }
    TestPipe.prototype.transform = function (text, pattern, flags) {
        if (!isString(text)) {
            return text;
        }
        return (new RegExp(pattern, flags)).test(text);
    };
    TestPipe.decorators = [
        { type: Pipe, args: [{ name: 'test' },] },
    ];
    /** @nocollapse */
    TestPipe.ctorParameters = function () { return []; };
    return TestPipe;
}());
export { TestPipe };
//# sourceMappingURL=test.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/string/test.js
// module id = 291
// module chunks = 4